import PropTypes from "prop-types";
import utils from "../../QlikUtils";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import KpiCard from "../../components/KPI/KpiCard";
import { useEffect, useState } from "react";

function MatrizLandingMobile({ app, config }) {
  const { container } = config.matriz;
  const [dataTable, setDataTable] = useState([]);
  const [fabricanteNome, setFabricanteNome] = useState("");

  const [modalOpened, setModalOpened] = useState(false);

  function showModal(pMercado, pCliente) {
    app.field("Perfil Mercado").selectMatch(pMercado, true);
    app.field("Perfil Cliente").selectMatch(pCliente, true);
    setModalOpened(true);
  }

  function showDetails() {
    app.field("Perfil Mercado").clear();
    app.field("Perfil Cliente").clear();
    setModalOpened(true);
  }

  function filterPerfil(pField, pPerfil) {
    app.field(pField).selectMatch(pPerfil, true);
  }

  function closeModal() {
    app.field("Perfil Mercado").clear();
    app.field("Perfil Cliente").clear();
    setModalOpened(false);
  }

  const initializeField = async () => {
    await utils.createHyperCubeByQlikIdToTable(
      app,
      // "13208c27-bf55-4b3e-a94f-bdbafc963025",
      "UPbJhuH",
      35,
      (res) => {
        setDataTable(utils.extractDataSet(res));
      }
    );
    await app.variable.getContent("vDescFabricanteNomeUpper", (reply) => {
      const data = reply.qContent.qString;
      setFabricanteNome(data);
    });
  };

  useEffect(() => {
    if (app) {
      initializeField();
    }
  }, [app]);

  return (
    <div className="app matriz">
      <div className="appContent">
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {container[0].cards.map((card, index) => {
            return (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "150px",
                }}
              >
                <KpiCard
                  key={index}
                  app={app}
                  KPITitle={{
                    id: card.title.id,
                    hardTitle: card.title.hardTitle,
                  }}
                  iconId={card.nativeObject.iconId}
                  percentageId={card.nativeObject.percentageId}
                  greyValueId={card.nativeObject.greyValueId}
                  valueId={card.nativeObject.valueId}
                  isMobile={false}
                  colorIdentfy={card.nativeObject.colorIdentfy}
                  tooltip={card.title.tooltip}
                ></KpiCard>
              </div>
            );
          })}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card
            className="tutorial-second-step"
            header={{
              hardTitle: container[1].cards[0].title.hardTitle,
              hardSubtitle: container[1].cards[0].subtitle.hard,
              tooltip: container[1].cards[0].title.tooltip,
            }}
            style={{ width: "100%", height: "100%", overflow: "auto"}}
            detailButton
            detailButtonAction={() => showDetails()}
          >
            {dataTable.length > 0 && (
              <div style={{ marginTop: "8px", width: "750px", paddingRight: "10px" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 6fr",
                  }}
                >
                  <div></div>
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#ccc",
                      color: "#142948",
                      fontWeight: "600",
                    }}
                  >
                    <p> {fabricanteNome} </p>
                  </div>
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: " repeat(8, 1fr)",
                  }}
                >
                  {/* LEGENDA LATERAL */}
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          height: "40px",
                        }}
                      ></div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "20px 20px 20px 1fr",
                        }}
                      >
                        {/* MERCADO */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateRows: "1fr 5fr",
                          }}
                        >
                          <div style={{ height: "60px" }}></div>
                          <div
                            style={{
                              width: "20px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              background: "#ccc",
                              color: "#142948",
                              fontWeight: "600",
                            }}
                          >
                            <span>M</span>
                            <span>E</span>
                            <span>R</span>
                            <span>C</span>
                            <span>A</span>
                            <span>D</span>
                            <span>O</span>
                          </div>
                        </div>
                        {/* DN QUALIFICA */}
                        <div
                          style={{
                            display: "grid",
                            paddingLeft: "1px",
                            gridTemplateRows: "1fr 4fr 1fr",
                          }}
                        >
                          <div style={{ height: "60px" }}></div>
                          <div
                            style={{
                              width: "20px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "start",
                              alignItems: "center",
                              background: "#417E8B",
                              color: "white",
                              borderRight: "1px solid white",
                            }}
                          >
                            <span>D</span>
                            <span>N</span>
                            <br />
                            <span>Q</span>
                            <span>U</span>
                            <span>A</span>
                            <span>L</span>
                            <span>I</span>
                            <span>F</span>
                            <span>I</span>
                            <span>C</span>
                            <span>A</span>
                          </div>
                        </div>
                        {/* DN TOP */}
                        <div
                          style={{
                            display: "grid",
                            paddingLeft: "1px",
                            gridTemplateRows: "1fr 3fr 2fr",
                          }}
                        >
                          <div style={{ height: "60px" }}></div>
                          <div
                            style={{
                              width: "20px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "start",
                              alignItems: "center",
                              background: "#3ABB99",
                              color: "white",
                            }}
                          >
                            <span>D</span>
                            <span>N</span>
                            <br />
                            <span>T</span>
                            <span>O</span>
                            <span>P</span>
                          </div>
                        </div>
                        {/* LEGENDA */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateRows: " repeat(6, 1fr)",
                            border: "1px solid #ccc",
                          }}
                        >
                          <div
                            style={{
                              height: "60px",
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <span>Total PDVs</span>
                          </div>
                          {/* PERFIL MERCADO HHB */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: dataTable[1][0].color,
                              color: "white",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              filterPerfil("Perfil Mercado", "HHB")
                            }
                          >
                            <span>HHB</span>
                          </div>
                          {/* PERFIL MERCADO HB */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: dataTable[6][0].color,
                              color: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => filterPerfil("Perfil Mercado", "HB")}
                          >
                            <span>HB</span>
                          </div>
                          {/* PERFIL MERCADO MB */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: dataTable[11][0].color,
                              color: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => filterPerfil("Perfil Mercado", "MB")}
                          >
                            <span>MB</span>
                          </div>
                          {/* PERFIL MERCADO LB */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: dataTable[16][0].color,
                              color: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => filterPerfil("Perfil Mercado", "LB")}
                          >
                            <span>LB</span>
                          </div>
                          {/* PERFIL MERCADO VLB */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: dataTable[21][0].color,
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              filterPerfil("Perfil Mercado", "VLB")
                            }
                          >
                            <span>VLB</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      border: "1px solid #ccc",
                    }}
                  >
                    <div
                      style={{
                        height: "38px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                        borderRight: "none",
                        borderBottom: "none",
                        borderTop: "none",
                        borderLeft: "none",
                      }}
                    >
                      <span>Total Geral</span>
                    </div>
                    <div
                      style={{
                        height: "60px",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                        border: "1px solid #ccc",
                        borderBottom: "none",
                        borderLeft: "none",
                        borderRight: "none",
                      }}
                    >
                      <span style={{ fontSize: "12px", fontWeight: "700" }}>
                        {dataTable[1][5].value}
                      </span>
                    </div>
                    {dataTable.map((element, index) => {
                      return (
                        index > 0 &&
                        index < 6 &&
                        dataTable[index].map((element, index) => {
                          let rgb =
                            element.color &&
                            element.color.replace("RGB", "rgb");
                          return (
                            (index == 4 || index == 8 || index == 15) && (
                              <div
                                style={
                                  index == 4
                                    ? {
                                        height: "20px",
                                        alignItems: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-around",
                                        border: "1px solid #ccc",
                                        borderBottom: "none",
                                        borderLeft: "none",
                                        borderRight: "none",
                                      }
                                    : {
                                        height: "20px",
                                        alignItems: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-around",
                                      }
                                }
                              >
                                {index == 4 && (
                                  <div>
                                    <span
                                      style={{
                                        fontSize: "10px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      {element.value}
                                    </span>
                                  </div>
                                )}
                                {index == 8 && (
                                  <div>
                                    <span
                                      style={{
                                        fontSize: "10px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      PDV {element.value}
                                    </span>
                                  </div>
                                )}
                                {index == 15 && (
                                  <div>
                                    <span
                                      style={{
                                        fontSize: "10px",
                                        fontWeight: "700",
                                      }}
                                    >
                                      R$ {element.value}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )
                          );
                        })
                      );
                    })}
                  </div>
                  {/* PERFIL CLIENTE HHB */}
                  <div>
                    <div
                      style={{
                        height: "40px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                        cursor: "pointer",
                        borderBottom: "none",
                        background: dataTable[1][0].color,
                        color: "white",
                      }}
                      onClick={() => {
                        filterPerfil("Perfil Cliente", "HHB");
                      }}
                    >
                      <span>HHB</span>
                    </div>
                    <div
                      style={{
                        height: "60px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          {dataTable[1][3].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          PDV {dataTable[1][7].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          R$ {dataTable[1][14].value}
                        </span>
                      </div>
                    </div>
                    {dataTable.map((elementFiltro, indexFiltro) => {
                      return (
                        indexFiltro > 0 &&
                        indexFiltro < 6 &&
                        dataTable[indexFiltro].map((element, index) => {
                          let rgb =
                            element.color &&
                            element.color.replace("RGB", "rgb");
                          return (
                            index == 2 && (
                              <div
                                onClick={() => {
                                  showModal(
                                    elementFiltro[1].value,
                                    elementFiltro[0].value
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  background: element.color
                                    ? element.color.replace("RGB", "rgb")
                                    : "",
                                  height: "60px",
                                  alignItems: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  border: "1px solid #ccc",
                                  borderTop: "none",
                                }}
                                key={index}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {element.value}
                                </span>
                              </div>
                            )
                          );
                        })
                      );
                    })}
                  </div>
                  {/* PERFIL CLIENTE HB */}
                  <div>
                    <div
                      style={{
                        height: "40px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                        borderBottom: "none",
                        background: dataTable[6][0].color,
                        color: "white",
                        cursor: "pointer",
                      }}
                      onClick={() => filterPerfil("Perfil Cliente", "HB")}
                    >
                      <span>HB</span>
                    </div>
                    <div
                      style={{
                        height: "60px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                      }}
                    >
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          {dataTable[6][3].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          PDV {dataTable[6][7].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          R$ {dataTable[6][14].value}
                        </span>
                      </div>
                    </div>
                    {dataTable.map((elementFiltro, indexFiltro) => {
                      return (
                        indexFiltro > 5 &&
                        indexFiltro < 11 &&
                        dataTable[indexFiltro].map((element, index) => {
                          let rgb =
                            element.color &&
                            element.color.replace("RGB", "rgb");
                          return (
                            index == 2 && (
                              <div
                                onClick={() => {
                                  showModal(
                                    elementFiltro[1].value,
                                    elementFiltro[0].value
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  background: element.color
                                    ? element.color.replace("RGB", "rgb")
                                    : "",
                                  height: "60px",
                                  alignItems: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  border: "1px solid #ccc",
                                  borderTop: "none",
                                  borderLeft: "none",
                                }}
                                key={index}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {element.value}
                                </span>
                              </div>
                            )
                          );
                        })
                      );
                    })}
                  </div>
                  {/* PERFIL CLIENTE MB */}
                  <div>
                    <div
                      style={{
                        height: "40px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                        borderBottom: "none",
                        background: dataTable[11][0].color,
                        color: "white",
                        cursor: "pointer",
                      }}
                      onClick={() => filterPerfil("Perfil Cliente", "MB")}
                    >
                      <span>MB</span>
                    </div>
                    <div
                      style={{
                        height: "60px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                      }}
                    >
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          {dataTable[11][3].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          PDV {dataTable[11][7].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          R$ {dataTable[11][14].value}
                        </span>
                      </div>
                    </div>
                    {dataTable.map((elementFiltro, indexFiltro) => {
                      return (
                        indexFiltro > 10 &&
                        indexFiltro < 16 &&
                        dataTable[indexFiltro].map((element, index) => {
                          let rgb =
                            element.color &&
                            element.color.replace("RGB", "rgb");
                          return (
                            index == 2 && (
                              <div
                                onClick={() => {
                                  showModal(
                                    elementFiltro[1].value,
                                    elementFiltro[0].value
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  background: element.color
                                    ? element.color.replace("RGB", "rgb")
                                    : "",
                                  height: "60px",
                                  alignItems: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  border: "1px solid #ccc",
                                  borderTop: "none",
                                  borderLeft: "none",
                                }}
                                key={index}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {element.value}
                                </span>
                              </div>
                            )
                          );
                        })
                      );
                    })}
                  </div>
                  {/* PERFIL CLIENTE LB */}
                  <div>
                    <div
                      style={{
                        height: "40px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                        borderBottom: "none",
                        background: dataTable[16][0].color,
                        color: "white",
                        cursor: "pointer",
                      }}
                      onClick={() => filterPerfil("Perfil Cliente", "LB")}
                    >
                      <span>LB</span>
                    </div>
                    <div
                      style={{
                        height: "60px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                      }}
                    >
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          {dataTable[16][3].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          PDV {dataTable[16][7].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          R$ {dataTable[16][14].value}
                        </span>
                      </div>
                    </div>
                    {dataTable.map((elementFiltro, indexFiltro) => {
                      return (
                        indexFiltro > 15 &&
                        indexFiltro < 21 &&
                        dataTable[indexFiltro].map((element, index) => {
                          let rgb =
                            element.color &&
                            element.color.replace("RGB", "rgb");
                          return (
                            index == 2 && (
                              <div
                                onClick={() => {
                                  showModal(
                                    elementFiltro[1].value,
                                    elementFiltro[0].value
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  background: element.color
                                    ? element.color.replace("RGB", "rgb")
                                    : "",
                                  height: "60px",
                                  alignItems: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  border: "1px solid #ccc",
                                  borderTop: "none",
                                  borderLeft: "none",
                                }}
                                key={index}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {element.value}
                                </span>
                              </div>
                            )
                          );
                        })
                      );
                    })}
                  </div>
                  {/* PERFIL CLIENTE VLB */}
                  {/* PERFIL CLIENTE VLB */}
                  <div>
                    <div
                      style={{
                        height: "40px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                        borderBottom: "none",
                        background: dataTable[21][0].color,
                        cursor: "pointer",
                      }}
                      onClick={() => filterPerfil("Perfil Cliente", "VLB")}
                    >
                      <span>VLB</span>
                    </div>
                    <div
                      style={{
                        height: "60px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          {dataTable[21][3].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          PDV {dataTable[21][7].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          R$ {dataTable[21][14].value}
                        </span>
                      </div>
                    </div>
                    {dataTable.map((elementFiltro, indexFiltro) => {
                      return (
                        indexFiltro > 20 &&
                        indexFiltro < 26 &&
                        dataTable[indexFiltro].map((element, index) => {
                          let rgb =
                            element.color &&
                            element.color.replace("RGB", "rgb");
                          return (
                            index == 2 && (
                              <div
                                onClick={() => {
                                  showModal(
                                    elementFiltro[1].value,
                                    elementFiltro[0].value
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  background: element.color
                                    ? element.color.replace("RGB", "rgb")
                                    : "",
                                  height: "60px",
                                  alignItems: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  border: "1px solid #ccc",
                                  borderTop: "none",
                                  borderLeft: "none",
                                }}
                                key={index}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {element.value}
                                </span>
                              </div>
                            )
                          );
                        })
                      );
                    })}
                  </div>
                  {/* PERFIL CLIENTE SEM COMPRA */}
                  <div>
                    <div
                      style={{
                        height: "40px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                        borderBottom: "none",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        filterPerfil("Perfil Cliente", "Sem Compra")
                      }
                    >
                      <span> Sem Compras </span>
                    </div>
                    <div
                      style={{
                        height: "60px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        border: "1px solid #ccc",
                      }}
                    >
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          {dataTable[26][3].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          PDV {dataTable[26][7].value}
                        </span>
                      </div>
                      <div>
                        {" "}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "700",
                          }}
                        >
                          R$ {dataTable[26][14].value}
                        </span>
                      </div>
                    </div>
                    {dataTable.map((elementFiltro, indexFiltro) => {
                      return (
                        indexFiltro > 25 &&
                        indexFiltro < 31 &&
                        dataTable[indexFiltro].map((element, index) => {
                          let rgb =
                            element.color &&
                            element.color.replace("RGB", "rgb");
                          return (
                            index == 2 && (
                              <div
                                onClick={() => {
                                  showModal(
                                    elementFiltro[1].value,
                                    elementFiltro[0].value
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  background: element.color
                                    ? element.color.replace("RGB", "rgb")
                                    : "",
                                  height: "60px",
                                  alignItems: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  border: "1px solid #ccc",
                                  borderTop: "none",
                                  borderLeft: "none",
                                }}
                                key={index}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {element.value}
                                </span>
                              </div>
                            )
                          );
                        })
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </Card>
        </div>
      </div>
    </div>
  );
}

MatrizLandingMobile.defaultProps = {
  app: null,
  config: {},
};

MatrizLandingMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default MatrizLandingMobile;
